const commonHeaders = {
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + localStorage.getItem('access_token')
}

export default {
  namespaced: true,
  state() {
    return {
      list: []
    }
  },
  actions: {
    load({commit}, data) {
      let url = `${data.path}/v2/bikes`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
          headers: commonHeaders,
        }).then(result => {
          commit('setList', result.data)
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    deleteTransfer(context, data) {
      let url = `${data.path}/v2/bikes/${data.bike_id}/transfer`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'DELETE',
          headers: commonHeaders,
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    transferAsSender(context, data) {
      let url = `${data.path}/v2/transfer/start`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'POST',
          headers: {...commonHeaders, ...{"front-ui": true}},
          data: data
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    transferAsRecipient(context, data) {
      let url = `${data.path}/v2/transfer/accept`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'POST',
          headers: commonHeaders,
          data: data
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    loadTransfer(context, data) {
      let url = `${data.path}/v2/transfer/show`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'POST',
          headers: commonHeaders,
          data: data
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    loadTransfers(context, data) {
      let url = `${data.path}/v2/transfer`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
          headers: commonHeaders
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    completeTransfer(context, data) {
      let url = `${data.path}/v2/transfer/complete`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'POST',
          headers: commonHeaders,
          data: data
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    cancelTransfer(context, data) {
      let url = `${data.path}/v2/transfer/cancel`;
      if (data.dispatch) {
        url += '?dispatch=true'
        if (data.only_started) {
          url += '?only_started=true'
        }
      }
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'POST',
          headers: commonHeaders,
          data: data
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    rename(context, data) {
      let url = `${data.path}/v2/bikes/${data.bikeID}/name`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'POST',
          headers: commonHeaders,
          data: data
        }).then(result => {
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    ridesStatistics({commit}, data) {
      let url = `${process.env.MIX__RIDE_SERVICE_API_ENDPOINT}/rides/stat`;
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'POST',
          headers: commonHeaders,
          data: data
        }).then(result => {
          commit('updateBikeStatistic', result.data.data)
          resolve(result.data)
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    }
  },
  mutations: {
    removeBikeFromList(state, bikeID) {
      state.list = state.list.filter(item => {
        return item.id !== bikeID
      })
    },
    setList(state, list) {
      state.list = list
    },
    updateList(state, data) {
      let list = [...state.list]
      state.list = list.map(item => {
        if (item.id === data.bike.id) {
          let newItem = {...item}
          newItem.front['custom_title'] = data.name
          item = newItem
        }
        return item
      })
    },
    updateBikeStatistic(state, statistics) {
      let list = [...state.list]
      state.list = list.map(item => {

        let exists = statistics.find(stat => {
          return stat.bike_id === item.id
        })

        if (exists) {
          item.stat = exists
        } else {
          item.stat = {
            maxOverload: 0,
            maxAirTime: 0,
            maxSpeed: 0,
            totalElevation: 0,
            distance: 0,
            time: 0,
          }
        }

        return item
      })
    }
  },
  getters: {
    list(state) {
      return state.list
    }
  }
}
